import React from 'react'
import { RefinementList, InfiniteHits, Configure, ClearRefinements, Hits } from 'react-instantsearch-dom'
import { InstantSearch, Index } from 'react-instantsearch-dom'
import { searchClient } from 'lib/algolia'
import { mapSearchHitToStory, mapSearchHitToProduct } from 'utils'

import DebouncedSearchBox from 'components/DebouncedSearchBox'
import StoryCard from 'components/StoryCard'
import StoreProduct from 'components/StoreProduct'
import { THEME } from 'utils'

const Search = ({ searchState, resultsState, onSearchStateChange, widgetsCollector }) => {
  const renderHit = (hit) => <StoryCard key={hit.objectId} story={mapSearchHitToStory(hit)} />
  const renderProductHit = (hit) => <StoreProduct key={hit.objectId} product={mapSearchHitToProduct(hit)} />

  const cleanTypes = (items) => {
    return items
      .filter((item) => item.label !== 'video_podcast')
      .map(({ label, ...rest }) => {
        return {
          label: label === 'barstool_original' ? 'Video' : label.replace(/[_-]/, ' '),
          ...rest
        }
      })
  }
  return (
    <>
      <InstantSearch
        indexName='BarstoolSports'
        searchClient={searchClient}
        searchState={searchState}
        resultsState={resultsState}
        widgetsCollector={widgetsCollector}
        onSearchStateChange={onSearchStateChange}
      >
        <Configure hitsPerPage={25} filters='site_barstoolsports=1' />
        <div className='container'>
          <div className='row row--main'>
            <div className='col col--main'>
              <div className='search'>
                <header>
                  <DebouncedSearchBox delay={1000} autoFocus showLoadingIndicator />
                </header>
                <content>
                  <menu>
                    <RefinementList attribute='categories' />
                  </menu>
                  <div id='hits-container'>
                    {searchState?.query ? <h1 className='search__title'>Results for "{searchState.query}"</h1> : null}
                    <div className='searchProducts'>
                      <p className='searchProducts__title'>
                        <span>{searchState?.query ? 'Related' : 'Trending'} products:</span>
                        <a
                          href={`https://store.barstoolsports.com/search?q=${
                            searchState?.query ?? ''
                          }&utm_source=barstoolsports&utm_medium=search-results-page&utm_term=${
                            searchState?.query ?? ''
                          }`}
                          target='_blank'
                          rel='noreferrer'
                        >
                          View all &rsaquo;
                        </a>
                      </p>
                      <Index indexName='shopify_products'>
                        <Configure hitsPerPage={4} distinct={1} filters='' />
                        <Hits hitComponent={(hit) => renderProductHit({ ...hit, query: searchState?.query ?? '' })} />
                      </Index>
                    </div>
                    <Index indexName='BarstoolSports'>
                      <InfiniteHits hitComponent={renderHit} />
                    </Index>
                  </div>
                </content>
              </div>
            </div>
            <div className='col col--sidebar'>
              <div className='sidebar'>
                <div className='searchFilters'>
                  <div className='searchFilters__header'>
                    <h3 className='searchFilters__title'>Filter Results</h3>
                  </div>
                  <h4 className='searchFilters__subTitle'>Post Type</h4>
                  <RefinementList attribute='type' transformItems={cleanTypes} />
                  <h4 className='searchFilters__subTitle'>Authors</h4>
                  <RefinementList attribute='authors' transformItems={cleanTypes} />
                  <div className='searchFilters__clear'>
                    <ClearRefinements />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </InstantSearch>
      <style jsx global>{`
        .search input[type='search'] {
          background-color: #ffffff;
        }
      `}</style>
      <style jsx>{`
        .row--main {
          margin-top: 24px;
          margin-bottom: 24px;
        }
        #hits-container {
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        #hits-container h1 {
          background-color: #ffffff;
          padding: 20px 20px 0 20px;
          margin: 0;
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 30px;
        }
        .sidebar {
          max-width: 300px;
          margin-left: auto;
          display: none;
          background-color: #ffffff;
        }
        .search__title {
          font-size: 20px;
          line-height: 25px;
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-top: 0;
        }
        .searchFilters {
          padding: 20px;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        .searchFilters__header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 16px;
          margin-bottom: 16px;
          border-bottom: 1px solid ${THEME.COLORS.LIGHTGRAY};
        }
        .searchFilters__title {
          font-size: 20px;
          font-weight: bold;
          line-height: 25px;
          margin: 0;
        }
        .searchFilters__subTitle {
          font-size: 16px;
          font-weight: bold;
          line-height: 25px;
          margin: 15px 0 0;
        }
        .searchProducts__title {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        }
        .searchProducts__title span {
          flex: 1;
          display: block;
          margin-right: 8px;
        }
        .searchProducts__title a {
          font-size: 15px;
          color: ${THEME.COLORS.LINKCOLOR};
        }
        @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
          .row--main {
            margin-top: 0px;
            margin-bottom: 0px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .sidebar {
            display: block;
          }
          .search__title {
            font-size: 32px;
            line-height: 40px;
          }
        }
      `}</style>
    </>
  )
}

export default Search
